export default "__VITE_ASSET__IDo3jV5h__"